// Agrupa a lista plana de serviços de uma rádio no formato que o APP_02 guarda
// e que o blockPage() das páginas espera:
//   [{ menu_label, item, subitens, vue_icon }]
// - serviço sem menu_group vira { menu_label: label, item, subitens: null }
// - serviços com o mesmo menu_group (case-insensitive) viram
//   { menu_label: menu_group, vue_icon, item: null, subitens: [...] }
// Resultado ordenado por menu_label.
export function groupServicesByMenu(list) {
  const services = []
  for (const item of list) {
    if (item.menu_group === null || item.menu_group === undefined || item.menu_group === '') {
      services.push({ menu_label: item.label, item: item, subitens: null })
    } else {
      const group = services.find(
        each => each.menu_label.toLowerCase() === item.menu_group.toLowerCase()
      )
      if (group !== undefined) {
        group.subitens.push(item)
      } else {
        services.push({
          menu_label: item.menu_group,
          vue_icon: item.vue_icon,
          item: null,
          subitens: [item]
        })
      }
    }
  }
  return services.sort((a, b) => a.menu_label.localeCompare(b.menu_label))
}
